module.exports = __webpack_public_path__ + "static/media/arrow-right.d2043d76.svg";